/**
 * The platform pieces the shared machine asks for. In the conformance runner
 * these are Node's; here they are the browser's. The machine cannot tell,
 * which is the point of injecting them.
 */

import type { TimerHost } from '@harness/stream-core';

export const browserTimers: TimerHost = {
  setTimeout: (callback, ms) => window.setTimeout(callback, ms),
  clearTimeout: (handle) => {
    window.clearTimeout(handle as number);
  },
};

export const now = (): number => performance.now();

export const random = (): number => Math.random();
